import script from "./ProductList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductList.vue?vue&type=script&lang=ts&setup=true"

import "./ProductList.vue?vue&type=style&index=0&id=77dd6ffc&lang=scss"

const __exports__ = script;

export default __exports__